import { Box, Card, SvgIcon, Typography } from '@mui/material';
import { ReactElement, useState } from 'react';
import { useParams } from 'react-router-dom';
import { PoliciesService } from 'services';
import { AppPrimaryButton } from 'shared/components/AppComponents';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import { Utils } from 'shared/helpers';
import { ReactComponent as Play } from 'assets/images/ic_play.svg';

const HealthCheck = (): ReactElement => {
  const [healthList, setHealthList] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);
  const { policyId } = useParams();

  const getHealtCheckDetails = (): any => {
    setIsLoading(true);
    PoliciesService.healthCheck(policyId)
      .then((res) => {
        const { data } = res.data;
        setHealthList(data);
      })
      .catch((error) => {
        Utils.handleErrorResponse(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <Box className="justify-space mt-5">
        <Box className="align-center">
          <MonitorHeartIcon
            sx={{
              marginRight: '10px',
            }}
            fontSize="large"
          />
          <div>
            {' '}
            <Typography variant="h3"> Policy Health Check </Typography>
            <Typography variant="body1">
              AI Power Analysis of your policy agent industry best practices
            </Typography>
          </div>
        </Box>
        <AppPrimaryButton
          title="Run Health Check"
          onClick={getHealtCheckDetails}
          isLoading={isLoading}
          startIcon={
            <SvgIcon
              component={Play}
              inheritViewBox
              className="view-icon"
              fontSize="inherit"
              htmlColor="white"
            />
          }
        />
      </Box>

      {healthList !== '' && (
        <Card className="p-5 mt-5">
          <pre
            style={{
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              overflowX: 'auto',
              maxWidth: '100%',
              fontFamily: 'sans-serif',
            }}
          >
            {healthList}
          </pre>
        </Card>
      )}
    </>
  );
};

export default HealthCheck;
